<div
  class="card card-list"
  id='scrollArea'
  [ngClass]="{ 'card-list-closed': closed }">
  <div class="card-header d-flex justify-content-between pr-0" i18n>
    <div
      class="group-pause-btn d-flex align-items-center"
      *ngIf="!closed">
      <button
        class="pause-btn"
        title="Pause/Resume"
        (click)="pauseOrResume()">
        <i class="material-icons" *ngIf="!paused">pause</i>
        <i class="material-icons" *ngIf="paused">play_arrow</i>
      </button>
    </div>
    <div
      class="group-list-mosaic-btn d-flex align-items-center"
      *ngIf="!closed">
      <button
        class="list-btn"
        title="Modo listagem"
        [ngClass]="{'active': viewMode === viewModes.list}"
        (click)="setViewMode(viewModes.list)">
        <i class="material-icons">table_rows</i>
      </button>
      <button
        class="mosaic-btn"
        title="Modo mosaico"
        [ngClass]="{'active': viewMode === viewModes.mosaic}"
        (click)="setViewMode(viewModes.mosaic)">
        <i class="material-icons">auto_awesome_mosaic</i>
      </button>
      <button
        class="mosaic-btn"
        [ngClass]="{'active':  viewFilters}"
        title="Aplicar Filtros"
        (click)="openOrCloseFilters()">
        <i class="material-icons">filter_alt</i>
      </button>
    </div>
    <div
      class="group-close-btn d-flex align-items-center"
      [ngClass]="{ 'group-close-btn-closed': closed }">
      <button
        class="close-btn"
        title="Fechar painel"
        (click)="closeOrOpenPanel()">
        <i class="material-icons" *ngIf="!closed">arrow_back_ios_new</i>
        <i class="material-icons" *ngIf="closed">arrow_forward_ios_new</i>
      </button>
    </div>
  </div>
  <div
    class="card-body card-body-list"
    [ngClass]="{ 'card-body-closed': closed }">
    <app-list
      *ngIf="viewMode === viewModes.list && !closed"
      [violations]="violations"
      [violationData]="violationData"
      [loadingList]="loadingList"
      [contract]="contract"
      [lastData]="lastData"
      (selectedViolation)="selectViolation($event)">
    </app-list>
    <app-mosaic-list
      *ngIf="viewMode === viewModes.mosaic && !closed"
      [violations]="violations"
      [violationData]="violationData"
      [loadingList]="loadingList"
      [closedPanel]="closed"
      [contract]="contract"
      [lastData]="lastData"
      (selectedViolation)="selectViolation($event)">
    </app-mosaic-list>
  </div>
</div>
